const assetProgressionData = [
  {
    month: ["2021", "Aug"],
    totalAssets: 4593872.24,
    liquidAssets: 3441645.23,
    totalReceivables: -15772.19,
    totalNoncurrentAssets: 864365.1,
    noncurrentAssetsPropertyPlantAndEquipment: -11235.62,
    cash: 836829.02,
    totalInventory: 2620588.4,
    currentAssets: 3729507.14,
  },
  {
    month: ["2021", "Sep"],
    totalAssets: 5019494.7,
    liquidAssets: 3868935.52,
    totalReceivables: -7198.36,
    totalNoncurrentAssets: 862572.87,
    noncurrentAssetsPropertyPlantAndEquipment: -16378.62,
    cash: 383270.55,
    totalInventory: 3492863.33,
    currentAssets: 4156921.83,
  },
  {
    month: ["2021", "Oct"],
    totalAssets: 5984192.71,
    liquidAssets: 4798523.89,
    totalReceivables: 17708.46,
    totalNoncurrentAssets: 857141.59,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 801144.55,
    totalInventory: 3979670.88,
    currentAssets: 5127051.12,
  },
  {
    month: ["2021", "Nov"],
    totalAssets: 6764845.33,
    liquidAssets: 5548845.97,
    totalReceivables: 391321.88,
    totalNoncurrentAssets: 857174.19,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1453189.69,
    totalInventory: 3704334.4,
    currentAssets: 5907671.14,
  },
  {
    month: ["2021", "Dec"],
    totalAssets: 6269656.43,
    liquidAssets: 5035201.15,
    totalReceivables: 383.81,
    totalNoncurrentAssets: 859623.69,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 2093477.41,
    totalInventory: 2941339.93,
    currentAssets: 5410032.74,
  },
  {
    month: ["2022", "Jan"],
    totalAssets: 5176376.59,
    liquidAssets: 3932703.98,
    totalReceivables: -21047.49,
    totalNoncurrentAssets: 859623.69,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 965303.76,
    totalInventory: 2988447.71,
    currentAssets: 4316752.9,
  },
  {
    month: ["2022", "Feb"],
    totalAssets: 5733235.75,
    liquidAssets: 4479273.21,
    totalReceivables: 1991.57,
    totalNoncurrentAssets: 859623.69,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1371971.53,
    totalInventory: 3105310.11,
    currentAssets: 4873612.06,
  },
  {
    month: ["2022", "Mar"],
    totalAssets: 4958143.1,
    liquidAssets: 3704489.59,
    totalReceivables: -3479.56,
    totalNoncurrentAssets: 859623.69,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 349492.07,
    totalInventory: 3358477.08,
    currentAssets: 4098519.41,
  },
  {
    month: ["2022", "Apr"],
    totalAssets: 5211921.08,
    liquidAssets: 3957060.37,
    totalReceivables: -30924.48,
    totalNoncurrentAssets: 859623.69,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 421236.79,
    totalInventory: 3566748.06,
    currentAssets: 4352297.39,
  },
  {
    month: ["2022", "May"],
    totalAssets: 4871050.91,
    liquidAssets: 3610983.37,
    totalReceivables: -34097.64,
    totalNoncurrentAssets: 859644.58,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 119722.82,
    totalInventory: 3525358.19,
    currentAssets: 4011406.33,
  },
  {
    month: ["2022", "Jun"],
    totalAssets: 5476439.08,
    liquidAssets: 4212280.18,
    totalReceivables: -20.16,
    totalNoncurrentAssets: 861545.94,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 412926.4,
    totalInventory: 3799373.94,
    currentAssets: 4614893.14,
  },
  {
    month: ["2022", "Jul"],
    totalAssets: 5731036.17,
    liquidAssets: 4465389.57,
    totalReceivables: 8117.27,
    totalNoncurrentAssets: 861545.94,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 496691.42,
    totalInventory: 3960580.88,
    currentAssets: 4869490.23,
  },
  {
    month: ["2022", "Aug"],
    totalAssets: 5970116.05,
    liquidAssets: 4654583.25,
    totalReceivables: 46032.86,
    totalNoncurrentAssets: 861556.83,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 299495.54,
    totalInventory: 4309054.85,
    currentAssets: 5108559.22,
  },
  {
    month: ["2022", "Sep"],
    totalAssets: 6244422.68,
    liquidAssets: 4903765.67,
    totalReceivables: 46130.14,
    totalNoncurrentAssets: 861556.83,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 144536.11,
    totalInventory: 4713099.42,
    currentAssets: 5382865.85,
  },
  {
    month: ["2022", "Oct"],
    totalAssets: 6669938.68,
    liquidAssets: 5317295.03,
    totalReceivables: 82938.78,
    totalNoncurrentAssets: 861556.83,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 511916.49,
    totalInventory: 4722439.76,
    currentAssets: 5808381.85,
  },
  {
    month: ["2022", "Nov"],
    totalAssets: 7232194.8,
    liquidAssets: 5845771.54,
    totalReceivables: 230226.18,
    totalNoncurrentAssets: 861556.83,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1500152.8,
    totalInventory: 4115392.56,
    currentAssets: 6370637.97,
  },
  {
    month: ["2022", "Dec"],
    totalAssets: 5657649.77,
    liquidAssets: 4270844.01,
    totalReceivables: 37037.3,
    totalNoncurrentAssets: 861556.83,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 776161.2,
    totalInventory: 3457645.51,
    currentAssets: 4796092.94,
  },
  {
    month: ["2023", "Jan"],
    totalAssets: 5964614.99,
    liquidAssets: 4560549.23,
    totalReceivables: -116872.35,
    totalNoncurrentAssets: 861556.83,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1496772.12,
    totalInventory: 3180649.46,
    currentAssets: 5103058.16,
  },
  {
    month: ["2023", "Feb"],
    totalAssets: 4503351.53,
    liquidAssets: 3085608.38,
    totalReceivables: -177711.94,
    totalNoncurrentAssets: 863099.82,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 35759.9,
    totalInventory: 3227560.42,
    currentAssets: 3640251.71,
  },
  {
    month: ["2023", "Mar"],
    totalAssets: 4722787.64,
    liquidAssets: 3291250.89,
    totalReceivables: -212246.1,
    totalNoncurrentAssets: 863099.82,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 330112.56,
    totalInventory: 3173384.43,
    currentAssets: 3859687.82,
  },
  {
    month: ["2023", "Apr"],
    totalAssets: 5360519.6,
    liquidAssets: 3916742.85,
    totalReceivables: -229700.88,
    totalNoncurrentAssets: 863099.82,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 834658.4,
    totalInventory: 3311785.33,
    currentAssets: 4497419.78,
  },
  {
    month: ["2023", "May"],
    totalAssets: 5657914.67,
    liquidAssets: 4240122.86,
    totalReceivables: -252452.88,
    totalNoncurrentAssets: 863099.82,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1189551.45,
    totalInventory: 3303024.29,
    currentAssets: 4794814.85,
  },
  {
    month: ["2023", "Jun"],
    totalAssets: 5541079.01,
    liquidAssets: 4149607.61,
    totalReceivables: -218572.91,
    totalNoncurrentAssets: 863142.81,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 853773.23,
    totalInventory: 3514407.29,
    currentAssets: 4677936.2,
  },
  {
    month: ["2023", "Jul"],
    totalAssets: 5385721.35,
    liquidAssets: 4019486.96,
    totalReceivables: -214352.97,
    totalNoncurrentAssets: 863185.8,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 565946.54,
    totalInventory: 3667893.39,
    currentAssets: 4522535.55,
  },
  {
    month: ["2023", "Aug"],
    totalAssets: 6113524.21,
    liquidAssets: 4755751.32,
    totalReceivables: -178551.69,
    totalNoncurrentAssets: 863185.8,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1051243.87,
    totalInventory: 3883059.14,
    currentAssets: 5250338.41,
  },
  {
    month: ["2023", "Sep"],
    totalAssets: 5840188.49,
    liquidAssets: 4509263.18,
    totalReceivables: -106412.01,
    totalNoncurrentAssets: 864214.76,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 229324.62,
    totalInventory: 4386350.57,
    currentAssets: 4975973.73,
  },
  {
    month: ["2023", "Oct"],
    totalAssets: 7186925.49,
    liquidAssets: 5742972.67,
    totalReceivables: -22437.69,
    totalNoncurrentAssets: 864214.76,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 1177695.44,
    totalInventory: 4587714.92,
    currentAssets: 6322710.73,
  },
  {
    month: ["2023", "Nov"],
    totalAssets: 8288649.98,
    liquidAssets: 6648302.65,
    totalReceivables: 46486.05,
    totalNoncurrentAssets: 864214.76,
    noncurrentAssetsPropertyPlantAndEquipment: -20772.62,
    cash: 2753910.17,
    totalInventory: 3847906.43,
    currentAssets: 7424435.22,
  },
  {
    month: ["2023", "Dec"],
    totalAssets: 7346455.69,
    liquidAssets: 5871865.99,
    totalReceivables: -5104.31,
    totalNoncurrentAssets: 680131.17,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 2623131.82,
    totalInventory: 3253838.48,
    currentAssets: 6666324.52,
  },
  {
    month: ["2024", "Jan"],
    totalAssets: 6973382.95,
    liquidAssets: 5506855.3,
    totalReceivables: 45544.36,
    totalNoncurrentAssets: 680131.17,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 2138036.21,
    totalInventory: 3323274.73,
    currentAssets: 6293251.78,
  },
  {
    month: ["2024", "Feb"],
    totalAssets: 6520360.97,
    liquidAssets: 5063132.98,
    totalReceivables: 100410.21,
    totalNoncurrentAssets: 680131.17,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1564853.85,
    totalInventory: 3397868.92,
    currentAssets: 5840229.8,
  },
  {
    month: ["2024", "Mar"],
    totalAssets: 6301637.87,
    liquidAssets: 4855452.5,
    totalReceivables: 195106.49,
    totalNoncurrentAssets: 681904.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1221752.51,
    totalInventory: 3438593.5,
    currentAssets: 5619732.95,
  },
  {
    month: ["2024", "Apr"],
    totalAssets: 5607513.1,
    liquidAssets: 4172322.51,
    totalReceivables: 236388.06,
    totalNoncurrentAssets: 681904.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 419327.05,
    totalInventory: 3516607.4,
    currentAssets: 4925608.18,
  },
  {
    month: ["2024", "May"],
    totalAssets: 6953444.48,
    liquidAssets: 5525829.13,
    totalReceivables: 326851.84,
    totalNoncurrentAssets: 681904.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1758261.13,
    totalInventory: 3440716.16,
    currentAssets: 6271539.56,
  },
  {
    month: ["2024", "Jun"],
    totalAssets: 6670771.66,
    liquidAssets: 5284191.3,
    totalReceivables: 379993.44,
    totalNoncurrentAssets: 681947.91,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1325360.54,
    totalInventory: 3578837.32,
    currentAssets: 5988823.75,
  },
  {
    month: ["2024", "Jul"],
    totalAssets: 6010165.65,
    liquidAssets: 4645681.19,
    totalReceivables: 403246.04,
    totalNoncurrentAssets: 681990.9,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 456598.43,
    totalInventory: 3785836.72,
    currentAssets: 5328174.75,
  },
  {
    month: ["2024", "Aug"],
    totalAssets: 6251917.74,
    liquidAssets: 4908545.89,
    totalReceivables: 402107.21,
    totalNoncurrentAssets: 681990.9,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 515308.36,
    totalInventory: 3991130.32,
    currentAssets: 5569926.84,
  },
  {
    month: ["2024", "Sep"],
    totalAssets: 6589615.64,
    liquidAssets: 5201638.28,
    totalReceivables: 378082.02,
    totalNoncurrentAssets: 681990.9,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 474504.22,
    totalInventory: 4349052.04,
    currentAssets: 5907624.74,
  },
  {
    month: ["2024", "Oct"],
    totalAssets: 6945624.8,
    liquidAssets: 5571499.41,
    totalReceivables: 137268.71,
    totalNoncurrentAssets: 681990.9,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 980222.92,
    totalInventory: 4454007.78,
    currentAssets: 6263633.9,
  },
  {
    month: ["2024", "Nov"],
    totalAssets: 7523522.73,
    liquidAssets: 6117144.64,
    totalReceivables: 321084.39,
    totalNoncurrentAssets: 681990.9,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1696292.61,
    totalInventory: 4099767.64,
    currentAssets: 6841531.83,
  },
  {
    month: ["2024", "Dec"],
    totalAssets: 7666761.97,
    liquidAssets: 6119622.88,
    totalReceivables: 326447.81,
    totalNoncurrentAssets: 807024.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 2574967.8,
    totalInventory: 3218207.27,
    currentAssets: 6859737.05,
  },
  {
    month: ["2025", "Jan"],
    totalAssets: 6813294.62,
    liquidAssets: 5250426.58,
    totalReceivables: 358863.31,
    totalNoncurrentAssets: 807024.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1584024.86,
    totalInventory: 3307538.41,
    currentAssets: 6006269.7,
  },
  {
    month: ["2025", "Feb"],
    totalAssets: 6941891.69,
    liquidAssets: 5368252.96,
    totalReceivables: 374293.99,
    totalNoncurrentAssets: 808524.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1647578.58,
    totalInventory: 3346380.39,
    currentAssets: 6133366.77,
  },
  {
    month: ["2025", "Mar"],
    totalAssets: 7909797.03,
    liquidAssets: 6341865.64,
    totalReceivables: 419974.55,
    totalNoncurrentAssets: 808524.92,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 2455371.49,
    totalInventory: 3466519.6,
    currentAssets: 7101272.11,
  },
  {
    month: ["2025", "Apr"],
    totalAssets: 7236867.53,
    liquidAssets: 5665791.26,
    totalReceivables: 422894.39,
    totalNoncurrentAssets: 810985.24,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1704202.32,
    totalInventory: 3538694.55,
    currentAssets: 6425882.29,
  },
  {
    month: ["2025", "May"],
    totalAssets: 7252907.99,
    liquidAssets: 5697728.36,
    totalReceivables: 419720.24,
    totalNoncurrentAssets: 810985.24,
    noncurrentAssetsPropertyPlantAndEquipment: -78113.52,
    cash: 1753981.91,
    totalInventory: 3524026.21,
    currentAssets: 6441922.75,
  },
  {
    month: ["2025", "Jun"],
    totalAssets: 7465486.35,
    liquidAssets: 5878520.82,
    totalReceivables: 453174.84,
    totalNoncurrentAssets: 811005.24,
    noncurrentAssetsPropertyPlantAndEquipment: -78093.52,
    cash: 1661007.56,
    totalInventory: 3764338.42,
    currentAssets: 6654481.11,
  },
  {
    month: ["2025", "Jul"],
    totalAssets: 7492212.09,
    liquidAssets: 5902546.56,
    totalReceivables: 450587.99,
    totalNoncurrentAssets: 811005.24,
    noncurrentAssetsPropertyPlantAndEquipment: -78093.52,
    cash: 1684309.07,
    totalInventory: 3767649.5,
    currentAssets: 6681206.85,
  },
];

export default assetProgressionData;
